/**
 * `EmptyState` (REDISENO-PANEL.md §2 "Estados vacíos", panel-redesign-v3
 * T1) — a dashed-border card with an optional secondary action suggesting
 * the next step (prototype: Tweaks → `datos = vacío`).
 */
export function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="v3-empty-state">
      <p className="v3-empty-state__title">{title}</p>
      <p className="v3-empty-state__text">{description}</p>
      {actionLabel && onAction && (
        <button type="button" className="v3-empty-state__action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
